import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { QueueService } from 'src/app/queue/queue/queue.service';
import { RouteName } from '../enums/RouteName';
import { ChannelService } from 'src/app/home/channel/channel.service';

@Injectable({
  providedIn: 'root'
})
export class QueueDataCheckGuard implements CanActivate {

  constructor(
    private queueService : QueueService,
    private channelService : ChannelService,
  ){}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      let currentRoute = this.channelService.getCurrentRouteName();

      if(this.queueService.getQueueData() && (currentRoute == RouteName.Cart || currentRoute == RouteName.Store || this.queueService.getIsQueueInfoPage())){
        this.queueService.showQuitQueuePopup();
        this.queueService.setIsQueueInfoPage(false);
        return false;
      }
      else{
        this.queueService.removeShowBackIcon();
        this.queueService.removeQueueData();
        this.queueService.removeActivityRsvToken();
        this.queueService.removeManualBack();
        return true;
      }
  }

}
